
import Vue from 'vue'
import axios from 'axios'
import communication from '../communication'

let request_count = 0
let response_count = 0

class Communicator extends Function {

  async getMethodWithAuth(url, accept_version = "1.0.0", accept_user = this.user.role) {
    return await axios.get(`${this.base_url}${url}`,
      {
        headers: {
          "Accept-version": accept_version,
          'Authorization': this.token,
          "Accept-user": accept_user,
        }
      })
      .catch(() => { })
  }

  async getRequest(endPoint, version = '1.0.0') {
    try {
      const headers = {
        'Accept-Version': version,
        'Authorization': this.token,
        'Accept-User': 'admin',
        'Content-Type': 'application/json'
      }
      const res = await axios.get(`${this.base_url}${endPoint}`, { headers: headers })

      return res.data.success ? ({
        data: res.data,
        error: null,
      }) : ({
        data: null,
        error: res.data.message,
      })

    } catch (err) {
      return ({
        data: null,
        error: err.message,
      })
    }
  }

  async getMethod(url) {

    return await axios.get(`${this.base_url}${url}`)
      .catch(() => { })
  }
  async postMethod(url, body) {
    const headers = {
      'Accept-Version': '1.0.0',
      'Authorization': this.token,
      'Accept-User': 'admin',
      'Content-Type': 'application/json'
    }
    return await axios.post(`${this.base_url}${url}`, body,
      {
        headers: headers
      })
      .catch(() => { })
  }

  async postMethod2(url, body) {
    const headers = {
      'Accept-Version': '2.0.0',
      'Authorization': this.token,
      'Accept-User': 'admin',
      'Content-Type': 'application/json'
    }
    return await axios.post(`${this.base_url}${url}`, body,
      {
        headers: headers
      })
      .catch(() => { })
  }
  async getFromTasnif(params) {
    const headers = {
      'Content-Type': 'application/json'
    };

    // const params = {
    //   mxikCode: id
    // };

    return await axios.get("https://tasnif.soliq.uz/api/cl-api/integration-mxik/get/information", {
      headers: headers,
      params: params
    }).catch(() => {
    });
  }

  async downloadDocumentPost(url, name, service_id) {
    let file_path = this.base_url + url
    let method = 'POST'
    // if (service_id) {
    //   await axios.post(
    //     this.base_url + url,
    //     { service: service_id },
    //     { responseType: 'json' },
    //   )
    //     .catch(() => { })
    //   file_path = await new Promise((resolve) => {
    //     const interval = setInterval(async () => {
    //       await axios.post(this.base_url + url, { service: service_id }, { responseType: 'json' }).then((response) => {
    //         if (response.data.data?.percentage == 100) {
    //           clearInterval(interval)
    //           resolve(`${this.base_url}static/${response.data.data?.path}`)
    //         }
    //       }).catch(() => { })
    //     }, 10000)
    //     method = 'GET'
    //   })
    // }
    await axios({
      method: method,
      url: file_path,
      responseType: 'blob',
      data: { service: service_id }

    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', name);
      document.body.appendChild(fileLink);

      fileLink.click();
    }).catch(() => { })
    return false
  }
  constructor(options = {}) {
    super()
    this.request_count = 0
    this.response_count = 0
    this.base_url = options.path
    // link.href = this.base_url + path
    this.http = axios.create({
      baseURL: options.path,
      headers: {
        'Accept-Version': '1.0.0',
        'Accept-User': 'admin'
      }
    })
    this.communications = options.communications
    this.user = {}
    this.token = 'guest'
    this.waiting_for_response = false
    return new Proxy(this, {
      apply: (target, _, args) => target._call(...args)
    })
  }
  printLabel(items) {
    var data = JSON.stringify(items);
    localStorage.setItem('print-items', data);
    window.location = '/print-label'
  }
  printLabelAll(items, type) {
    var data = JSON.stringify(items);
    localStorage.setItem('print-items', data);
    window.location = '/print-label-all?type=' + type
  }
  clear_phone_number(value, is = false) {
    var phone_number = ''
    for (const index in value) {
      if ('0' <= value[index] && value[index] <= '9') {
        phone_number = phone_number + value[index]
      }
    }
    if (is) return phone_number
    return '+998' + phone_number
  }
  clear_phone_number_second(value, is = false) {
    var phone_number = ''
    for (const index in value) {
      if ('0' <= value[index] && value[index] <= '9') {
        phone_number = phone_number + value[index]
      }
    }
    if (is) return phone_number
    return '+' + phone_number
  }
  make_phone_number(value) {
    if (value.length > 0 && value[0] == '+') {
      value = value.slice(4)
    }
    else {
      if ((value.length == 3 || value.length == 10) && value[0] == '9' && value[1] == '9' && value[2] == '8') {
        value = value.slice(3)
      }
    }
    return value
  }
  make_phone_number_second(value) {
    value = value.slice(1);
    // if (value.length > 0 && value[0] == '+') {
    //   value = value.slice(4);
    // }
    // else {
    //   if ((value.length == 3 || value.length == 10) && value[0] == '9' && value[1] == '9' && value[2] == '8') {
    //     value = value.slice(3)
    //   }
    // }
    return value;
  }
  async uploadFile(path, formData) {
    const uploadAxios = require('axios');
    uploadAxios.defaults.headers.common['Authorization'] = this.token;
    uploadAxios.defaults.headers.common['Accept-User'] = 'admin';
    uploadAxios.defaults.data = formData;
    return await uploadAxios.post(this.base_url + path, formData);
  }
  async file(path, files, image = false) {
    var headers = new Headers()
    var formdata = new FormData()
    if (image) {
      formdata.append('image', files['file'])
    }
    else {
      formdata.append('file', files['file'])
      headers.append('Accept-Version', '1.0.0')
      headers.append('Accept-User', 'admin')
      headers.append('Authorization', this.token)
    }
    var options = {
      method: 'POST',
      headers: headers,
      body: formdata,
      redirect: 'follow'
    };
    if (image) {
      return await axios.post(this.base_url + path, formdata, {
        headers: headers
      })
    }
    else {
      return fetch(this.base_url + path, options)
    }
  }
  async file1(path, files) {
    var headers = new Headers()
    var formdata = new FormData()
    formdata.append('excel', files['file'])
    headers.append('Accept-Version', '2.0.0')
    headers.append('Accept-User', 'admin')
    headers.append('Authorization', this.token)

    var options = {
      method: 'POST',
      headers: headers,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(this.base_url + path, options)
  }
  async downloadDocument(url, name, version) {
    const data = {
      url: this.base_url + url,
      method: 'GET',
      timeout: 300000,
      responseType: 'blob',
    }
    if (version) {
      data.headers = {
        'Accept-Version': version,
        'Authorization': this.token,
        'Accept-User': 'admin',
        'Content-Type': 'application/json'
      };
    }

    await axios(data).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', name);
      document.body.appendChild(fileLink);

      fileLink.click();
    }).catch(() => { })
  }
  download(path) {
    var link = document.createElement('a')
    link.setAttribute("target", "_blank");
    link.href = this.base_url + path
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  auth(user, token, app) {
    this.user = user
    this.token = token
    if (app) {
      this.app = app
    }
  }
  showError(data) {
    switch (data.statusCode) {
      case 50000: {
        this.app.errors.push({
          name: this.app.$t('allready_exist'),
          value: 1,
          color: 'error'
        })
        break;
      }
    }
  }
  then(_, response) {
    try {
      if (response?.status == 200 && response?.data?.statusCode == 200) {
        return response?.data?.data
      }
      this.showError(response?.data)
      return response?.data
    }
    catch (error) {
      return error
    }
  }
  queryToRoute(query) {
    const result = Object.keys(query).map(k => `${k}=${query[k]}`).join('&')
    return result
  }
  _call(...args) {
    request_count++
    this.waiting_for_response = true
    const _path = (communication, name, payload) => {
      var path = [name]
      if (payload && payload.arguments) {
        path.push(payload.arguments)
      }
      if (payload && payload.page) {
        const num = payload.page.num ? payload.page.num : 10
        const page = payload.page.page ? payload.page.page : 1
        path.push([num, page])
      }
      if (payload && payload.id) {
        path.push(payload.id)
      }
      if (communication && communication.create) {
        path.push('create')
      }
      path = path.flat(Infinity).join('/')
      return path
      // return payload && payload?.query ? `${path}?${payload.query}` : path
    }
    var [name, payload] = args
    if (this.communications[name]) {
      const is_put = this.communications[name].put
      const is_delete = this.communications[name].method_delet
      const is_patch = this.communications[name].patch
      const is_post = this.communications[name].post || (
        !this.communications[name].get && payload && payload.params)

      const apiVersion = this.communications[name].version || '1.0.0'

      const query = payload?.query
      let link = this.communications[name].link
      if (query) {
        link += `?${this.queryToRoute(query)}`
      }
      let path = _path(this.communications[name], link, payload)
      const method = is_put
        ? 'PUT' : is_patch
          ? 'PATCH' : is_delete
            ? 'DELETE' : is_post
              ? 'POST' : (this.communications[name].remove ? 'DELETE' : 'GET');
      var headers = {
        'Accept-User': 'admin',
        'Content-Type': 'application/json',
        'Accept-Version': apiVersion
      }
      if (!this.communications[name].guest) { headers['Authorization'] = this.token }
      var options = { method, headers, url: path }
      if (this.communications[name].service) {
        if (!payload) payload = {}
        if (!payload.params) {
          payload.params = {}
        }
        payload.params['service'] = this.user['service']
      }
      if (is_post) { options.data = payload.params }

      const app = this.app
      if (this.token == 'guest' && (!['signup', 'signin', 'verify'].includes(name))) {
        response_count++
        return {}
      }

      options.transformResponse = [(data) => {
        response_count++
        if (response_count == request_count) {
          this.waiting_for_response = false
        }
        if (typeof data == typeof 'invan') {
          if (data == 'Unauthorized') {
            app.logout()
            return null
          }
          return JSON.parse(data)
        }
        return data
      }]

      return this.http(options)
    }
  }
  static install(Vue) {
    const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    if (options.communicator) {
      Vue.prototype.$communicator = options.communicator
    }
  }
}

const BASE_URL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_BASE_URL_DEBUG : process.env.VUE_APP_BASE_URL_PROD

const communicator = new Communicator({
  path: BASE_URL,
  communications: communication.communications
})

const install = Communicator.install
Communicator.install = (Vue, options = {}) => {
  install.call(Communicator, Vue, {
    communicator,
    ...options
  })
}

Vue.use(Communicator)

export default communicator
